// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"500":"f3c6577c","507":"18935a48","751":"18935a48"}[chunkId] + ".chunk.css");